export default __webpack_public_path__ + "static/media/pin.8907cc4d.svg";